import { memo, ReactNode } from 'react'

import { CopyAll } from '@mui/icons-material'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'

import { CodeInline } from '@shared/components/MaterialUIEnhancements/CodeInline'

export type Props = {
  label: string
  /** Rendered as a copyable monospace value. Empty or missing shows a placeholder. */
  value?: string
  /** Custom value rendering — takes precedence over `value` unless nullish. */
  children?: ReactNode
}

const DetailRowRaw = ({ label, value, children }: Props) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="heading-xs">{label}</Typography>
      {children ?? (
        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
          <CodeInline sx={{ width: '100%', color: value ? undefined : 'text.disabled' }} noWrap>
            {value || '-'}
          </CodeInline>
          {/* Nothing to put on the clipboard when the value is absent. */}
          {!!value && (
            <CopyToClipboard text={value}>
              <Tooltip title={t('clickToCopy')} placement="right">
                <IconButton size="small">
                  <CopyAll fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </CopyToClipboard>
          )}
        </Box>
      )}
    </Box>
  )
}

export const DetailRow = memo(DetailRowRaw)
